import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {FooterModuleStoreClickEventHandler} from "./footer-module.store-click-event.handler";
import {SearchClickHandler} from "../../../../../core/handlers/search-click.handler";
import {FooterModuleItemClickEventHandler} from "./footer-module.item-click-event.handler";
import {FooterModuleVersionClickDebugHandler} from "./footer-module.version-click-debug.handler";
import {FooterModuleFetchHandler} from "./footer-module.fetch-handler";

export class FooterModuleHandlers extends HandlerList {
  static injectables = [
    FooterModuleFetchHandler,
    FooterModuleStoreClickEventHandler,
    FooterModuleItemClickEventHandler,
    FooterModuleVersionClickDebugHandler,
    SearchClickHandler,
    TimingHandler
  ];

  constructor(
    footerModuleFetchHandler: FooterModuleFetchHandler,
    footerModuleStoreClickEventHandler: FooterModuleStoreClickEventHandler,
    footerModuleItemClickEventHandler: FooterModuleItemClickEventHandler,
    footerModuleVersionClickDebugHandler: FooterModuleVersionClickDebugHandler,
    searchClickHandler: SearchClickHandler,
    timingHandler: TimingHandler
  ) {
    super();

    [
      footerModuleFetchHandler,
      footerModuleStoreClickEventHandler,
      footerModuleItemClickEventHandler,
      footerModuleVersionClickDebugHandler,
      searchClickHandler,
      timingHandler
    ].forEach(handler => this.add(handler));
  }
}
